import { render } from "./Results5.vue?vue&type=template&id=712aedf9&scoped=true"
import script from "./Results5.vue?vue&type=script&lang=js"
export * from "./Results5.vue?vue&type=script&lang=js"

import "./Results5.vue?vue&type=style&index=0&id=712aedf9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-712aedf9"]])

export default __exports__